<template>
  <div class="page-container">
    <div class="tip">请选择要认领的热点</div>
    <div class="list-container">
      <div v-if="loading" class="loading">加载中，请稍候...</div>
      <template v-else>
        <wifi-item
          v-for="(item, index) in wifiList"
          :key="index"
          :item="item"
          @click="handleWifiItemClick"
        />
      </template>
      <div class="empty" v-if="isShowEmpty">请在设置>更多设置>权限管理中，授权WiFi万能钥匙开启定位权限，才能查找附近WiFi</div>
    </div>
    <div class="button-container">
      <button
        class="refresh-button"
        @click="refreshList"
        type="primary"
        block
        :disabled="loading"
      >刷新列表</button>
    </div>
  </div>
</template>

<script>
import WifiItem from "./components/WifiItem";
import Toast from '../../components/toast'
export default {
  name: 'newwifiSelect',
  components: {
    "wifi-item": WifiItem,
  },

  data() {
    return {
      loading: false,
      wifiList: [],
      isShowEmpty: false,
      key: null,
      refresh: false
    };
  },

  created() {
    this.init();
    this.key = this.$route.query.key
  },

  methods: {
    init() {
      this.$wkb.call("getWiFiList", {
        success: (res) => {
          console.log()
          if ((res.length === 0 || !res) && this.refresh) {
            this.$toast('请确认位置权限已开启')
            return
          }
          if (res.length === 0) {
            this.isShowEmpty = true
          }
          this.wifiList = res;
          if (this.refresh) { this.$toast('刷新成功'); this.refresh = false}
        },
      });
    },

    refreshList() {
      this.refresh = true;
      this.init();
    },

    handleWifiItemClick(val = {}) {
      this.$trace.trace('ins_join_ssid_listcli');
      sessionStorage.setItem('SELECT_WIFI', JSON.stringify({...val, key: this.key}))
      this.$router.back()
      console.log("wifi item click", val);
    },
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.tip {
  flex: none;
  padding: 10px 16px;
  font-size: 14px;
  color: #999;
  background-color: #eee;
}

.list-container {
  flex: auto;
  overflow-y: scroll;
  background: white;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: #999;
}

.button-container {
  flex: none;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.refresh-button {
  color: #fff;
  border-radius: 4px;
  font-size: 16px;
  left: 10%;
  line-height: 40px;
  width: 80%;
  background: #0082f1;
  border: none;
}
.empty {
  position: relative;
  height: 100%;
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// index.vue?6c2999cc